<template>
  <b-button
    class="gradient-button border-gradient"
    variant="outline-primary"
    @click="$emit('click', $event)"
    pill
  >
    <div class="button-content text-gradient bold">
      <slot></slot>
    </div>
  </b-button>
</template>

<script>
import { BButton } from 'bootstrap-vue'

/**
 * This gives a button component and gradient border and text color.
 */
export default {
  name: 'GradientButton',
  props: [],
  components: { BButton },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.gradient-button {
  background: $documentColor !important;
  color: $brand !important;
  border: none;
  &:hover .text-gradient {
    background: -webkit-linear-gradient(left, #007ef2, #be0eee);
    -webkit-background-clip: text;
  }
}
</style>
